export const getCommandBarItems = (
  translator,
  onChangeSubjectAreaIsActive,
  selectedSubjectAreaIsActive,
  selectedSubjectAreaId,
  onDeleteSubjectArea,
  isUpdatingSubjectArea,
  selectedSubjectAreaNumberOfHearings,
  openPanel,
) => {
  return [
    {
      key: 'addSubjectArea',
      name: translator('pages.adminSubjectAreas.addSubjectArea'),
      iconProps: {
        iconName: 'Add',
      },
      onClick: openPanel,
      disabled: false,
      buttonStyles,
    },
    {
      key: 'activateSubjectArea',
      name: translator('pages.adminSubjectAreas.activateSubjectArea'),
      iconProps: {
        iconName: 'ActivateOrders',
      },
      onClick: () => onChangeSubjectAreaIsActive(true),
      disabled:
        isUpdatingSubjectArea ||
        selectedSubjectAreaIsActive === null ||
        selectedSubjectAreaIsActive,
      buttonStyles,
    },
    {
      key: 'deactivateSubjectArea',
      name: translator('pages.adminSubjectAreas.inactivateSubjectArea'),
      iconProps: {
        iconName: 'DeactivateOrders',
      },
      onClick: () => onChangeSubjectAreaIsActive(false),
      disabled: isUpdatingSubjectArea || !selectedSubjectAreaIsActive,
      buttonStyles,
    },
    {
      key: 'deleteSubjectArea',
      name: translator('pages.adminSubjectAreas.deleteSubjectArea'),
      iconProps: {
        iconName: 'Delete',
      },
      onClick: onDeleteSubjectArea,
      disabled:
        isUpdatingSubjectArea ||
        selectedSubjectAreaId === null ||
        selectedSubjectAreaNumberOfHearings !== 0,
      buttonStyles,
    },
  ];
};

const buttonStyles = {
  root: {
    backgroundColor: '#FAFAFA',
  },
  rootDisabled: {
    backgroundColor: '#FAFAFA',
  },
};
